import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'

interface FilingProgressData {
  name: string
  value: number
  color: string
  [key: string]: any
}

interface FilingProgressChartProps {
  data?: FilingProgressData[]
  className?: string
}

const defaultData: FilingProgressData[] = [
  { name: 'Submitted', value: 25, color: '#374151' },
  { name: 'New', value: 30, color: '#F87171' },
  { name: 'In-view', value: 31, color: '#A78BFA' },
  { name: 'Accepted', value: 14, color: '#34D399' },
]

const FilingProgressChart: React.FC<FilingProgressChartProps> = ({
  data = defaultData,
  className = '',
}) => {
  const total = data.reduce((sum, item) => sum + item.value, 0)
  const acceptedValue = data.find(item => item.name === 'Accepted')?.value || 0
  const acceptedPercentage =
    total > 0 ? Math.round((acceptedValue / total) * 100) : 0

  return (
    <div className={`w-full ${className}`}>
      {/* Chart Container */}
      <div className='flex flex-col items-center justify-center py-4'>
        <div className='relative w-[240px] h-[240px] mb-6'>
          <ResponsiveContainer width='100%' height='100%'>
            <PieChart>
              <Pie
                data={data}
                cx='50%'
                cy='50%'
                innerRadius={70}
                outerRadius={110}
                startAngle={90}
                endAngle={450}
                paddingAngle={2}
                dataKey='value'
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          {/* Center Label */}
          <div className='absolute inset-0 flex items-center justify-center'>
            <div
              className='text-center bg-white rounded-md px-3 py-2'
              style={{
                boxShadow: '0px 6px 16px 0px rgba(20, 23, 31, 0.15)',
              }}
            >
              <div className='text-base font-semibold text-[#14171F]'>
                {acceptedPercentage}%
              </div>
              <div className='text-xs font-medium text-black'>Accepted</div>
            </div>
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className='flex flex-wrap justify-center gap-3 text-sm text-[#414651]'>
        {data.map((item, index) => (
          <div key={index} className='flex items-center gap-1'>
            <div
              className='w-2.5 h-2.5 rounded-full'
              style={{ backgroundColor: item.color }}
            ></div>
            <span>{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilingProgressChart
